// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"e_YB","legend":"e_ZB","legendContent":"e__B","contentWrapper":"e_0B","fieldsetContent":"e_1B"};